import { legacy_createStore as createStore } from "redux";
import rootReducer from "./Reducer/rootReducer";

function configureStore(state = { bgColor: "black", activeColor: "info" }) {
  return createStore(rootReducer,state);
}
export default configureStore;